import React from "react";
import { useSelector } from "react-redux";
import { getProducts } from "../redux/products/productsReducer";
import Product from "./Product";

const ProductList = () => {
  const products = useSelector(getProducts);
  return (
    <div className="col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-8 xxl:col-span-8">
      {products.map((product) => (
        <Product key={product.productId} product={product} />
      ))}
    </div>
  );
};

export default ProductList;
